export default {
  namespaced: true,
  dmp: {
    title: "DMP",
    name: "Nombre",
    panel_model: "Modelo",
    panel_mac_addr: "Dirección MAC",
    panel_serial_num: "Número de serie",
    panel: "Panel",
    autoDetectPanel: "Detectar panel(es) automáticamente",
    autoDetectPanelHint: "Usa el/los panel(es) de la unidad de la alarma en automático",
    dateRange: "Rango de días",
    dateRangeNone: "Ninguno",
    dateRangeLast30: "Últimos 30 días",
    dateRangeLast60: "Últimos 60 días",
    dateRangeHint: "Se calcula desde el momento en que se abre la vista de la alarma",
    template: "Template",
    panels: "Paneles",
    host: "Host",
    port: "Puerto",
    client_password: "Contraseña del cliente",
    remote_control_password: "Contraseña de control remoto",
    listening_port: "Puerto de escucha",
    facilities: "Instalaciones",
    eventDefinition: "Definición del evento",
    event_code: "Código del evento",
    alarm_type_sbo: "Tipo de alarma (SBO)",
    description: "Descripción",
    zone: "Zona",
    num_conact_id: "Número de cuenta Contact ID",
    creation_date: "Fecha de creación",
    isRecovered: "Recuperado",
    recovered_yes: "Sí",
    recovered_no: "No",
    date: "Fecha",
    masterAccounts: "cuentas maestras",
    masterAccount: "cuenta maestra",
    first_name: "nombre",
    last_name: "apellido",
    link: "enlace",
    username: "Usuario",
    token: "token",
    password: "contraseña",
    token_expired: "expiración del token",
    email: "correo electrónico",
    sites: "sitios",
    site: "sitio",
    address: "dirección",
    latitude: "latitud",
    longitude: "longitud",
    timeZone: "zona horaria",
    profile: "perfil",
    profiles: "perfiles",
    calendar: "calendario",
    serialNumber: "número de serie",
    actions: "acciones",
    schemaTypes: "tipos de esquema",
    schema_type: "tipo de esquema",
    display_name: "nombre para mostrar",
    id: "id",
    devicesSection: "dispositivos",
    gateway_id: "id de gateway",
    schema_actions: "acciones del esquema",
    typeAlarm: "tipo de alarma",
    typeAlarms: "tipos de alarma",
    priority: "prioridad",
    checkRemoteUser: "verificar usuario remoto",
    dispatchAlarm: "despachar alarma",
    alarms: "alarmas",
    state: "estado",
    creation_time: "hora de creación",
    units: "instalaciones",
    center: "centro",
    sector: "sector",
    device: "dispositivo",
    schemaEvent: "evento",
    time: "hora",
    logs: "registros",
    channel: "canal",
    name_panel: "nombre del panel",
    events: "eventos",
    syncCorrectly: "sincronizado correctamente",
    status: "Estado",
    instance_host: "Host de la instancia",
    rules: "Reglas",
    code: "Código",
    event: "Evento",
    event_id: "ID del evento",
    value: "Valor",
    zones_pgm: "Zona / PGM",
    pgm_output: "PGM / Salida",
    partition: "Partición",
    alias: "Alias",
    syncPanel: "Sincronizar panel",
    syncPanelWarning: "La sincronización puede tardar algunos minutos",
    syncing: "Sincronizando",
    withoutProfile: "El panel no tiene un perfil asignado",
    reconnect: "Reconectar",
    restart: "Reiniciar",
    rebuild: "Reconstruir",
    profile_name: "Perfil",
    type: "Tipo",
    category: "Categoría",
    active: "Activo",
    activate: "Activar",
    deactivate: "Desactivar",
    close: "Cerrar",
    open: "Abrir",
    bypass: "Bypass",
    enable: "Habilitar",
    panelOffline: "El panel está desconectado",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Desconectado",
    arm: "Armar",
    disarm: "Desarmar",
    armPanel: "Armar panel",
    disarmPanel: "Desarmar panel",
    arming: "Armando",
    disarming: "Desarmando",
    armedCorrectly: "Armado correctamente",
    disarmedCorrectly: "Desarmado correctamente",
    uuid: "UUID",
    connected: "Conectado",
    disconnected: "Desconectado",
    deviceType: 'Tipo de dispositivo',
    deviceId: "ID de dispositivo",
    deviceName: "Nombre de dispositivo",
    eventType: "Tipo de evento",
    areaId: "ID de área",
    userId: "ID de usuario",
    alarmType: "Tipo de alarma",
    areaArmed: "Armada",
    areaDisarmed: "Desarmada",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    area: "Área",
    eventDate: "Fecha del evento",
    servers: "Servidores",
    url: "URL",
    count: "Núm. de instancias",
    panelHost: "Host del panel",
    panelAccount: "Cuenta del panel",
    panelRemoteKey: "Clave remota del panel",
    alarmId: "ID de alarma",
    activating: "Activando",
    deactivating: "Desactivando",
    saving: "Guardando...",
    syncDevices: "Sincronizar dispositivos",
    syncDevicesSuccess: "Dispositivos sincronizados correctamente",
    syncDevicesError: "Error al sincronizar los dispositivos",
    tag: "Etiqueta",
    tags: "Etiquetas",
    searchResults: "Resultados de la búsqueda",
    noResults: "Sin resultados",
    required: "Obligatorio",
    isRecovered: "Recuperado",
    enabled_zones_audit: "Habilitar auditoría de zonas",
    days_zones_audit: "Días de auditoría de zonas",
    enabled_areas_audit: "Habilitar auditoría de áreas",
    days_areas_audit: "Días de auditoría de áreas",
    dateAndTimezone: "Fecha & Zona horaria",
    current: "Actual",
    messages: {
      executeCommandConfirm: "¿Ejecutar el comando '%command%' en '%device%'?",
      commandExecutedSuccess: "comando '%command%' ejecutado correctamente",
      commandExecutedError: "error al ejecutar el comando '%command%'",
      areYouSureTo: "¿Seguro que deseas %action% %device%?",
      areYouSure: "¿Seguro que deseas ejecutar '%action%' en %device%?",
      categoryGroupChangeWarning: "¿Aplicar la categoría a todos los elementos, incluidos los que ya tienen una diferente?",
      tagAppliedSuccess: "Etiqueta aplicada correctamente",
      areaTagApplyToZones: "¿Aplicar también esta etiqueta a todas las zonas del área? Se reemplazarán sus etiquetas actuales.",
      areaTagRemoveFromZones: "¿Quitar también las etiquetas de todas las zonas del área?",
      areaTagIncludeZones: "Sí, también las zonas",
      areaTagOnlyArea: "No, solo el área",
      tagRemovedSuccess: "Etiqueta eliminada correctamente",
    },
    devices: {
      area: {
        actions: {
          Arm: 'Armada',
          Disarm: 'Desarmada'
        },
        title: 'área'
      },
      output: {
        actions: {
          Momentary: 'momentánea',
          Off: 'apagada',
          Pulse: 'pulsada',
          Steady: 'fija',
          'Temporal 3': 'Temporal 3'
        },
        title: 'salida'
      },
      zone: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reiniciar'
        },
        title: 'zona'
      },
      zone24h: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reiniciar'
        },
        title: 'zona 24h'
      },
      panel: {
        title: 'panel',
        actions: {
          'Arm Panel': 'Armar panel',
          'Disarm Panel': 'Desarmar panel',
          'Alarm silence': 'Silenciar alarma',
          'Sensor reset': 'Reiniciar sensores'
        }
      },
      door: {
        title: 'puerta',
        actions: {
          'Door Access': 'Acceso a la puerta',
          'Lock Door': 'Bloquear puerta',
          'Unlock Door': 'Desbloquear puerta'
        }
      }
    },
    deviceStatuses: {
      ARMED: 'Armado',
      DISARMED: 'Desarmado',
      NORMAL: 'Normal',
      OPEN: 'Abierto',
      BYPASSED: 'En bypass',
      OFF: 'Apagado',
      ON: 'Encendido',
      OFFLINE: 'Desconectado',
      ONLINE: 'Conectado',
      LOCKED: 'Bloqueado',
      UNLOCKED: 'Desbloqueado',
      TROUBLE: 'Falla',
    },
    panelInfo: {
      panel: 'Panel',
      tamper: 'Tamper',
      acPower: 'Alimentación CA',
      battery: 'Batería',
      printer: 'Impresora',
      wireless: 'Inalámbrico',
      phoneLine1: 'Línea telefónica 1',
      phoneLine2: 'Línea telefónica 2',
    },
    wizard: {
      add: {
        title: "Asistente para agregar DMP",
      },
      edit: {
        title: "Asistente para editar DMP",
      },
      steps: {
        general: "General",
        users: "Usuarios",
        communicationPaths: "Rutas de comunicación",
      }
    },
    config: "Configuración",
    configSections: {
      users: "Usuarios",
      communicationPaths: "Rutas de Comunicación",
      general: "Configuración General",
      areaInformation: "Información de Áreas",
      outputInformation: "Información de Salidas",
      deviceSetup: "Configuración de Dispositivos",
      outputOptions: "Opciones de Salida",
      areaSchedules: "Horarios de Áreas",
      timeSchedules: "Horarios",
      bellOptions: "Opciones de Campana",
      networkOptions: "Opciones de Red",
      remoteOptions: "Opciones Remotas",
      holidayDates: "Días Festivos",
      outputGroups: "Grupos de Salida",
      systemOptions: "Opciones del Sistema",
      profiles: "Perfiles",
      zoneInformation: "Información de Zonas",
    },
    outputInformation: {
      title: "Información de salidas",
      outputs: "Salidas",
      addOutput: "Agregar salida",
      editOutput: "Editar salida",
      noOutputsConfigured: "No hay salidas configuradas",
      outputNumber: "Número de salida",
      outputName: "Nombre de la salida",
      outputDetails: "Detalles de la salida",
      description: "Descripción",
      loadingOutputs: "Cargando salidas...",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar esta salida?",
        limitReached: "Límite alcanzado",
        maxOutputsAllowed: "Número máximo de salidas permitidas",
        validationError: "Error de validación",
        outputNumberExists: "El número de salida ya existe",
        outputSavedSuccess: "Salida guardada correctamente",
        outputsLoadError: "No se pudieron cargar las salidas",
        outputDeleteSuccess: "Salida eliminada correctamente",
        outputDeleteError: "No se pudo eliminar la salida",
        outputSaveError: "No se pudo guardar la salida",
        outputAddedSuccess: "Salida agregada correctamente",
        outputUpdatedSuccess: "Salida actualizada correctamente",
        syncSuccess: "Salidas sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las salidas"
      }
    },
    outputGroups: {
      title: "Grupos de salida",
      groups: "Grupos",
      addGroup: "Agregar grupo",
      editGroup: "Editar grupo",
      noGroupsConfigured: "No hay grupos configurados",
      groupNumber: "Número de grupo",
      groupName: "Nombre del grupo",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar este grupo?",
        limitReached: "Límite alcanzado",
        maxGroupsAllowed: "Número máximo de grupos permitidos",
        validationError: "Error de validación",
        groupNumberExists: "El número de grupo ya existe",
        groupSavedSuccess: "Grupo guardado correctamente",
        groupsLoadError: "No se pudieron cargar los grupos",
        groupDeleteSuccess: "Grupo eliminado correctamente",
        groupDeleteError: "No se pudo eliminar el grupo",
        groupSaveError: "No se pudo guardar el grupo"
      }
    },
    outputOptions: {
      title: "Opciones de salida",
      settings: "Ajustes",
      save: "Guardar cambios",
      options: "Opciones",
      energySaving: "Ahorro de energía",
      outputs: "Salidas",
      cutoffOutputs: "Salidas de corte",
      cutoffOutputsRange: "Rango: 0, 1-6",
      cutoffTime: "Tiempo de corte",
      cutoffTimeRange: "Rango: 0, 55-95",
      heatSaverTemp: "Temperatura de ahorro de calefacción",
      coolSaverTemp: "Temperatura de ahorro de refrigeración",
      temperatureRange: "Rango: 0, 55-95",
      commFailOutput: "Salida por falla de comunicación",
      fireAlarmOutput: "Salida de alarma de incendio",
      fireTroubleOutput: "Salida de falla de incendio",
      panicAlarmOutput: "Salida de alarma de pánico",
      ambushOutput: "Salida de coacción",
      entryDelayOutput: "Salida de retardo de entrada",
      beginExitOutput: "Salida de inicio de salida",
      endExitOutput: "Salida de fin de salida",
      readyOutput: "Salida de listo",
      phoneTroubleOutput: "Salida de falla telefónica",
      lateToCloseOutput: "Salida de cierre tardío",
      deviceFailedOutput: "Salida de dispositivo con falla",
      sensorResetOutput: "Salida de reinicio de sensores",
      closingWaitOutput: "Salida de espera de cierre",
      disarmedOutput: "Salida de desarmado",
      armAlarmOutput: "Salida de alarma de armado",
      supervisoryAlarmOutput: "Salida de alarma de supervisión",
      armedHomePerimeterOutput: "Salida Casa/Perímetro",
      armedAllAwayOutput: "Salida Todo/Ausente",
      armedSleepOutput: "Salida Dormir",
      carbonMonoxideOutput: "Salida de monóxido de carbono",
      lockdownOutput: "Salida de bloqueo",
      zoneMonitorOutput: "Salida de monitor de zonas",
      loadingOutputs: "Cargando opciones de salida...",
      messages: {
        saveSuccess: "Opciones de salida guardadas correctamente",
        saveError: "No se pudieron guardar las opciones de salida",
        loadError: "No se pudieron cargar las opciones de salida",
        syncSuccess: "Opciones de salida sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las opciones de salida"
      }
    },
    systemOptions: {
      title: "Opciones del sistema",
      settings: "Ajustes",
      save: "Guardar cambios",
      saving: "Guardando...",
      options: "Opciones",
      miscellaneousOptions: "Opciones varias",
      languages: "Idiomas",
      timeChange: "Cambio de hora",
      delays: "Retardos",
      wireless: "Inalámbrico",
      advancedOptions: "Opciones avanzadas",
      systemArmingType: "Tipo de armado del sistema",
      instantArm: "Armado instantáneo",
      closingWait: "Espera de cierre",
      resetSwingerBypass: "Reiniciar swinger bypass",
      enableKeypadPanicKeys: "Habilitar teclas de pánico del teclado",
      enhancedZoneTest: "Prueba de zonas mejorada",
      send16Characters: "Enviar nombres de 16 caracteres",
      useFalseAlarmQuestion: "Usar pregunta de falsa alarma",
      allowOwnUserCodeChange: "Permitir cambiar el propio código de usuario",
      panicSupervision: "Supervisión de pánico",
      keypadArmedLed: "LED de armado del teclado",
      swingerBypassTrips: "Disparos para swinger bypass",
      bypassLimit: "Límite de bypass",
      weatherZipCode: "Código postal del clima",
      occupiedPremises: "Local ocupado",
      primaryProgrammingLang: "Idioma principal de programación",
      secondaryProgrammingLang: "Idioma secundario de programación",
      primaryUserLang: "Idioma principal del usuario",
      secondaryUserLang: "Idioma secundario del usuario",
      hoursFromGMT: "Horas desde GMT",
      timeChangeOption: "Cambio de hora",
      zoneActivityHours: "Horas de actividad de zonas",
      entryDelay1: "Retardo de entrada 1",
      entryDelay2: "Retardo de entrada 2",
      entryDelay3: "Retardo de entrada 3",
      entryDelay4: "Retardo de entrada 4",
      crossZoneTime: "Tiempo de zona cruzada",
      zoneRetardDelay: "Retardo de zona",
      powerFailDelay: "Retardo por falla de energía",
      wirelessHouseCode: "Código de casa inalámbrico",
      troubleAudible: "Falla audible",
      detectWirelessJamming: "Detectar interferencia inalámbrica",
      latchSupervisory: "Enclavar supervisión",
      eolResistor: "Selector de resistencia EOL",
      useCelsiusTemperature: "Temperatura en Celsius",
      observeDST: "Aplicar horario de verano",
      encryptionSettings: "Cifrado inalámbrico 1100",
      encryptionPassphrase: "Frase de contraseña 1100",
      loadingSystemOptions: "Cargando opciones del sistema...",
      timeChangeOptions: {
        receiver: "Receptor",
        noChange: "Sin cambio de hora",
        secureCom: "SecureCom",
      },
      encryptionSettingsOptions: {
        none: "Ninguno",
        all: "Todos",
        both: "Ambos"
      },
      armingTypes: {
        area: "Área",
        all: "Todo",
        guest: "Invitado",
        home: "Casa"
      },
      keypadLedOptions: {
        any: "Cualquiera",
        day: "Día",
        minimum: "Mínimo"
      },
      languages: {
        title: "Idiomas",
        none: "Ninguno",
        english: "Inglés",
        spanish: "Español",
        french: "Francés",
        czech: "Checo",
        greek: "Griego",
        dutch: "Neerlandés"
      },
      troubleAudibleOptions: {
        any: "Cualquiera",
        day: "Día",
        minimum: "Mín"
      },
      messages: {
        saveSuccess: "Opciones del sistema guardadas correctamente",
        saveError: "No se pudieron guardar las opciones del sistema",
        loadError: "No se pudieron cargar las opciones del sistema",
        validationError: "Error de validación",
        validationErrorText: "Corrige los errores del formulario",
        syncSuccess: "Opciones del sistema sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las opciones del sistema"
      }
    },
    areaInformation: {
      globalSettings: "Ajustes globales (se aplican a todas las áreas)",
      saveGlobalSettings: "Guardar ajustes globales",
      exitDelay: "Retardo de salida",
      burglaryBellOutput: "Salida de campana de robo",
      earlyMorningAmbush: "Coacción de madrugada",
      closingCheck: "Verificación de cierre",
      areaSchedules: "Horarios de áreas",
      closingCode: "Código de cierre",
      anyBypass: "Cualquier bypass",
      areas: "Áreas",
      addArea: "Agregar área",
      editArea: "Editar área",
      noAreasConfigured: "No hay áreas configuradas",
      loadingAreas: "Cargando áreas...",
      areaDetails: "Detalles del área",
      areaNumber: "Número de área",
      areaName: "Nombre del área",
      accountNumber: "Número de cuenta",
      accountNumberHint: "Número de cuenta de 4 dígitos (opcional)",
      badZones: "Zonas en falla",
      armedOutput: "Salida de armado",
      lateOutput: "Salida por retraso",
      lateArmDelay: "Retardo de armado tardío",
      twoManRule: "Regla de dos personas",
      options: "Opciones",
      openCloseReports: "Reportes de apertura/cierre",
      autoArming: "Armado automático",
      autoDisarm: "Desarmado automático",
      bankSafeAndVault: "Caja fuerte y bóveda",
      commonArea: "Área común",
      armFirst: "Armar primero",
      cardPin: "Tarjeta + PIN",
      bypassOptions: {
        bypass: "Bypass",
        forceArm: "Armado forzado",
        refuseArm: "Rechazar armado"
      },
      noYes: {
        no: "No",
        yes: "Sí"
      },
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar esta área?",
        deleteConfirmText: "Esta acción no se puede deshacer",
        limitReached: "Límite alcanzado",
        maxAreasAllowed: "Máximo 99 áreas permitidas",
        validationError: "Error de validación",
        areaNumberExists: "El número de área ya existe",
        globalSettingsSaved: "Ajustes globales guardados correctamente",
        globalSettingsError: "No se pudieron guardar los ajustes globales",
        areasSavedSuccess: "Área guardada correctamente",
        areaAddedSuccess: "Área agregada correctamente",
        areaUpdatedSuccess: "Área actualizada correctamente",
        areasLoadError: "No se pudieron cargar las áreas",
        areasReloadSuccess: "Áreas recargadas correctamente",
        areasReloadError: "No se pudieron recargar las áreas. Inténtalo de nuevo.",
        areaDeleteSuccess: "Área eliminada correctamente",
        areaDeleteError: "No se pudo eliminar el área",
        areaSaveError: "No se pudo guardar el área",
        syncSuccess: "Áreas sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las áreas"
      }
    },
    outputGroups: {
      title: "Grupos de salida",
      groups: "Grupos",
      addGroup: "Agregar grupo",
      editGroup: "Editar grupo",
      groupDetails: "Detalles del grupo de salida",
      noGroupsConfigured: "No hay grupos configurados",
      groupNumber: "Número de grupo",
      groupName: "Nombre del grupo",
      outputNumber: "Número de salida",
      loadingGroups: "Cargando grupos de salida...",
      messages: {
        deleteConfirm: "Eliminar grupo",
        deleteConfirmText: "¿Seguro que deseas eliminar este grupo de salida?",
        limitReached: "Límite alcanzado",
        maxGroupsAllowed: "Número máximo de grupos permitidos",
        validationError: "Error de validación",
        groupNumberExists: "El número de grupo ya existe",
        groupAddedSuccess: "Grupo de salida agregado correctamente",
        groupUpdatedSuccess: "Grupo de salida actualizado correctamente",
        groupSavedSuccess: "Grupo de salida guardado correctamente",
        groupsLoadError: "No se pudieron cargar los grupos de salida",
        groupDeleteSuccess: "Grupo de salida eliminado correctamente",
        groupDeleteError: "No se pudo eliminar el grupo de salida",
        groupSaveError: "No se pudo guardar el grupo de salida",
        atLeastOneOutput: "Se debe configurar al menos una salida para el grupo",
        syncSuccess: "Grupos de salida sincronizados correctamente",
        syncError: "No se pudieron sincronizar los grupos de salida"
      }
    },
    holidayDates: {
      title: "Días festivos",
      addHoliday: "Agregar día festivo",
      editHoliday: "Editar día festivo",
      noHolidaysConfigured: "No hay días festivos configurados",
      loadingHolidays: "Cargando días festivos...",
      number: "Número",
      name: "Nombre",
      class: "Clase",
      date: "Fecha",
      holidayDate: "Fecha del día festivo",
      description: "Descripción",
      selectClass: "Selecciona una clase",
      holidayDetails: "Detalles del día festivo",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar este día festivo?",
        limitReached: "Límite alcanzado",
        maxHolidaysAllowed: "Máximo 99 días festivos permitidos",
        validationError: "Error de validación",
        validationErrorText: "Completa correctamente todos los campos obligatorios",
        numberExists: "El número de día festivo ya existe",
        dateExists: "Esta fecha ya existe",
        saveSuccess: "Día festivo guardado correctamente",
        saveError: "No se pudo guardar el día festivo",
        loadError: "No se pudieron cargar los días festivos",
        deleteSuccess: "Día festivo eliminado correctamente",
        deleteError: "No se pudo eliminar el día festivo",
        syncSuccess: "Días festivos sincronizados correctamente",
        syncError: "No se pudieron sincronizar los días festivos"
      }
    },
    users: {
      title: "Usuarios",
      configuredUsers: "Usuarios configurados",
      addUser: "Agregar usuario",
      editUser: "Editar usuario",
      noUsersConfigured: "No hay usuarios configurados",
      loadingUsers: "Cargando usuarios...",
      userNumber: "Número",
      userCode: "Código",
      userName: "Nombre",
      userPin: "PIN del usuario",
      activeUser: "Usuario activo",
      status: "Estado",
      active: "Activo",
      inactive: "Inactivo",
      profiles: "Perfiles",
      noProfiles: "Sin perfiles",
      noProfile: "Sin asignar",
      profile: "Perfil",
      range: "Rango: 1-9999",
      userCodeHint: "0-9a-z, máx. 12",
      userPinHint: "6 dígitos (opcional)",
      userNameHint: "Máx. 20",
      userDetails: "Detalles del usuario",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar este usuario?",
        userSavedSuccess: "Usuario guardado correctamente",
        userAddedSuccess: "Usuario agregado correctamente",
        userUpdatedSuccess: "Usuario actualizado correctamente",
        userDeleteSuccess: "Usuario eliminado correctamente",
        usersLoadError: "No se pudieron cargar los usuarios",
        userSaveError: "No se pudo guardar el usuario",
        userDeleteError: "No se pudo eliminar el usuario",
        pinMustBe6Digits: "El PIN debe tener exactamente 6 dígitos o estar vacío",
        userCodeOnlyAlphanumeric: "El código de usuario solo puede contener números y letras minúsculas",
        profileOnlyNumbers: "El perfil {number} solo puede contener números (1-3 dígitos)",
        userNumberExists: "El número de usuario ya existe",
        userCodeExists: "El código de usuario ya existe",
        atLeastOneProfile: "Se debe indicar al menos un perfil"
      }
    },
    communicationPaths: {
      title: "Rutas de comunicación",
      addPath: "Agregar ruta",
      editPath: "Editar ruta de comunicación",
      addCommunicationPath: "Agregar ruta de comunicación",
      editCommunicationPath: "Editar ruta de comunicación",
      noPathsConfigured: "No hay rutas de comunicación configuradas",
      loadingPaths: "Cargando rutas...",
      communicationPathDetails: "Detalles de la ruta de comunicación",
      pathNumber: "Número de ruta",
      receiverIp: "IP del receptor",
      receiverPort: "Puerto del receptor",
      protocol: "Protocolo",
      accountNumber: "Número de cuenta",
      communicationTrouble: "Falla de comunicación",
      doorAccess: "Acceso a puertas",
      selectProtocol: "Selecciona el protocolo",
      selectOption: "Selecciona una opción",
      tcp: "TCP",
      udp: "UDP",
      yes: "Sí",
      no: "No",
      deny: "Denegar",
      pathNumberHint: "Ingresa el número de ruta (1-8)",
      receiverIpHint: "Ingresa la dirección IP del receptor",
      receiverPortHint: "Puerto",
      accountNumberHint: "Número de cuenta de 4 dígitos (opcional)",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar esta ruta de comunicación?",
        deleteConfirmText: "Esta acción no se puede deshacer",
        limitReached: "Límite alcanzado",
        maxPathsAllowed: "Máximo 8 rutas de comunicación permitidas",
        pathSavedSuccess: "Ruta de comunicación guardada correctamente",
        pathCreatedSuccess: "Ruta de comunicación creada correctamente",
        pathUpdatedSuccess: "Ruta de comunicación actualizada correctamente",
        pathDeleteSuccess: "Ruta de comunicación eliminada correctamente",
        pathsLoadError: "No se pudieron cargar las rutas de comunicación",
        pathSaveError: "No se pudo guardar la ruta de comunicación",
        pathDeleteError: "No se pudo eliminar la ruta de comunicación",
        validationError: "Error de validación",
        pathNumberExists: "El número de ruta ya existe",
        ipPortExists: "La combinación de IP y puerto ya existe",
        syncSuccess: "Rutas de comunicación sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las rutas de comunicación"
      }
    },
    remoteOptions: {
      title: "Opciones remotas",
      save: "Guardar cambios",
      saving: "Guardando...",
      standard: "Estándar",
      entre: "Entré",
      general: "General",
      dialer: "Marcador",
      network: "Red",
      cellular: "Celular",
      mobileApplication: "Aplicación móvil",
      programSync: "Sincronización de programación",
      entreSettings: "Ajustes de Entré",
      remoteKey: "Clave remota",
      remoteDisarm: "Desarmado remoto",
      armedAnswerRings: "Timbres para contestar armado",
      disarmedAnswerRings: "Timbres para contestar desarmado",
      pcModem: "Módem de PC",
      alarmReceiver: "Receptor de alarmas",
      serviceReceiver: "Receptor de servicio",
      allowNetworkRemote: "Permitir remoto por red",
      encryptNetworkRemote: "Cifrar remoto por red",
      encryptNetworkRemoteWarning: "Advertencia: habilitar esta opción puede desconectar el panel.",
      networkProgrammingPort: "Puerto de programación por red",
      allowCellularRemote: "Permitir remoto por celular",
      encryptCellRemote: "Cifrar remoto por celular",
      encryptCellRemoteWarning: "Advertencia: habilitar esta opción puede desconectar el panel.",
      firstGprsApn: "Primer APN GPRS",
      secondGprsApn: "Segundo APN GPRS",
      appKey: "Clave de la aplicación",
      sendLocalChanges: "Enviar cambios locales",
      remoteChangeIp: "IP de cambios remotos",
      remoteChangePort: "Puerto de cambios remotos",
      remotePhoneNumber: "Número telefónico remoto",
      entreConnection: "Conexión Entré",
      entreIncomingTcpPort: "Puerto TCP entrante de Entré",
      entreIp: "IP de Entré",
      entreOutboundTcpPort: "Puerto TCP saliente de Entré",
      entreBackupIp: "IP de respaldo de Entré",
      entreBackupTcpPort: "Puerto TCP de respaldo de Entré",
      entreArmDisarmReports: "Reportes de armado/desarmado de Entré",
      entreZoneReports: "Reportes de zonas de Entré",
      entreUserCommandReports: "Reportes de comandos de usuario de Entré",
      entreDoorReports: "Reportes de acceso a puertas de Entré",
      entreSupervisoryReports: "Reportes de supervisión de Entré",
      entreCheckInMinutes: "Minutos de chequeo de Entré",
      entrePassphrase: "Frase de contraseña de Entré",
      none: "Ninguno",
      yes: "Sí",
      no: "No",
      dd: "DD",
      loadingRemoteOptions: "Cargando opciones remotas...",
      messages: {
        saveSuccess: "Opciones remotas guardadas correctamente",
        saveError: "No se pudieron guardar las opciones remotas",
        loadError: "No se pudieron cargar las opciones remotas",
        validationError: "Error de validación",
        validationErrorText: "Corrige los errores del formulario antes de guardar",
        invalidIpFormat: "Formato de dirección IP no válido",
        syncSuccess: "Opciones remotas sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las opciones remotas"
      }
    },
    bellOptions: {
      title: "Opciones de campana",
      optionsSection: "Opciones",
      miscellaneousOptions: "Opciones varias",
      fireBellAction: "Acción de campana de incendio",
      burglaryBellAction: "Acción de campana de robo",
      supervisoryBellAction: "Acción de campana de supervisión",
      panicBellAction: "Acción de campana de pánico",
      emergencyBellAction: "Acción de campana de emergencia",
      aux1BellAction: "Acción de campana Aux 1",
      aux2BellAction: "Acción de campana Aux 2",
      carbonMonoxideAction: "Acción de monóxido de carbono",
      bellCutoffTime: "Tiempo de corte de campana",
      bellCutoffTimeHint: "Rango: 1-99",
      automaticBellTest: "Prueba automática de campana",
      bellOutput: "Salida de campana",
      bellOutputHint: "Formato: 000-999",
      loading: "Cargando opciones de campana",
      actions: {
        none: "Ninguna",
        steady: "Fija",
        pulse: "Pulsada",
        temporal3: "Temporal 3",
        temporal4: "Temporal 4",
      },
      savedSuccessfully: "Opciones de campana guardadas correctamente",
      errorSaving: "Error al guardar las opciones de campana",
    },
    networkOptions: {
      title: "Opciones de red",
      options: "Opciones",
      wifiSettings: "Ajustes de Wi-Fi",
      localIp: "Dirección IP local",
      gateway: "Dirección de gateway",
      subnetMask: "Máscara de subred",
      dnsServer: "Servidor DNS",
      encryptionPassphrase: "Frase de contraseña de cifrado",
      listenPort734n: "Puerto de escucha 734N",
      passphrase734n: "Frase de contraseña 734N",
      ssid: "SSID",
      security: "Seguridad",
      wifiPassword: "Contraseña de Wi-Fi",
      securityNone: "Ninguna",
      securityWep: "WEP",
      securityWpa: "WPA",
      dhcp: "DHCP",
      dhcpWarning: "Advertencia: habilitar esta opción puede desconectar el panel.",
      loadingNetworkOptions: "Cargando opciones de red...",
      messages: {
        saveSuccess: "Opciones de red guardadas correctamente",
        saveError: "No se pudieron guardar las opciones de red",
        loadError: "No se pudieron cargar las opciones de red",
        validationError: "Error de validación",
        validationErrorText: "Corrige los errores del formulario",
        syncSuccess: "Opciones de red sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las opciones de red"
      }
    },
    common: {
      success: "Éxito",
      error: "Error",
      loading: "Cargando información del panel",
      panelNotFound: "Panel no encontrado",
      panelNotFoundMessage: "No se pudo encontrar el panel solicitado",
      no: "No",
      yes: "Sí"
    },
    profiles: {
      title: "Perfiles",
      configuredProfiles: "Perfiles configurados",
      addProfile: "Agregar perfil",
      editProfile: "Editar perfil",
      deleteProfile: "Eliminar perfil",
      noProfilesConfigured: "No hay perfiles configurados",
      loadingProfiles: "Cargando perfiles...",
      profileNumber: "Número",
      profileName: "Nombre",
      name: "Nombre",
      number: "Número",
      profileNumberHint: "Rango: 1-99",
      profileNameHint: "Máx. 20 caracteres",
      profileDetails: "Detalles del perfil",
      generalSettings: "Ajustes generales",
      areasAccess: "Áreas y acceso",
      schedules: "Horarios",
      permissions: "Permisos",
      armDisarmAreas: "Áreas para armar/desarmar",
      armDisarmAreasHint: "Áreas que este perfil puede armar/desarmar",
      accessAreas: "Áreas de acceso",
      accessAreasHint: "Áreas a las que este perfil tiene acceso",
      outputGroup: "Grupo de salida",
      outputGroupHint: "Rango: 0-99",
      reArmDelay: "Retardo de rearmado",
      reArmDelayHint: "Retardo en minutos (0-999)",
      inactiveUserAuditDays: "Días de auditoría de usuarios inactivos",
      inactiveUserAuditDaysHint: "Días antes de marcar usuarios inactivos (0-999)",
      schedule: "Horario",
      arm: "Armar",
      disarm: "Desarmar",
      alarmSilence: "Silenciar alarma",
      lockdown: "Bloqueo",
      doorLockUnlock: "Bloquear/desbloquear puerta",
      sensorReset: "Reinicio de sensores",
      doorAccess: "Acceso a puertas",
      armedAreas: "Áreas armadas",
      outputsOnOff: "Encender/apagar salidas",
      zoneStatus: "Estado de zonas",
      bypassZones: "Zonas en bypass",
      zoneMonitor: "Monitor de zonas",
      systemStatus: "Estado del sistema",
      systemTest: "Prueba del sistema",
      userCodes: "Códigos de usuario",
      setTime: "Ajustar hora",
      displayEvents: "Mostrar eventos",
      serviceRequest: "Solicitud de servicio",
      fireDrill: "Simulacro de incendio",
      extend: "Extender",
      tempCode: "Código temporal",
      antiPassback: "Anti-passback",
      easyArmDisarm: "Armado/desarmado fácil",
      useSecondaryLanguage: "Usar idioma secundario",
      cardPlusPIN: "Tarjeta + PIN",
      wiFiSetup: "Configuración de Wi-Fi",
      technicianUser: "Usuario técnico",
      lockdownOverride: "Anulación de bloqueo",
      dualAuthority: "Doble autoridad",
      privateDoors: "Puertas privadas",
      privateDoor: "Puerta privada",
      noSchedule: "Sin asignar",
      noDoor: "Sin asignar",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar este perfil?",
        deleteConfirmText: "Esta acción no se puede deshacer",
        limitReached: "Límite alcanzado",
        maxProfilesAllowed: "Máximo 99 perfiles permitidos",
        validationError: "Error de validación",
        validationErrorText: "Corrige los errores del formulario",
        profileNumberExists: "El número de perfil ya existe",
        profileSavedSuccess: "Perfil guardado correctamente",
        profileCreatedSuccess: "Perfil creado correctamente",
        profileUpdatedSuccess: "Perfil actualizado correctamente",
        profileDeleteSuccess: "Perfil eliminado correctamente",
        profilesLoadError: "No se pudieron cargar los perfiles",
        profileSaveError: "No se pudo guardar el perfil",
        profileDeleteError: "No se pudo eliminar el perfil",
        syncSuccess: "Perfiles sincronizados correctamente",
        syncError: "No se pudieron sincronizar los perfiles"
      }
    },
    zoneInformation: {
      title: "Información de zonas",
      None: "Ninguna",
      zones: "Zonas",
      zoneDetails: "Detalles de la zona",
      standard: "Estándar",
      action: "Acción",
      wirelessVPlex: "Inalámbrico/VPlex",
      advanced: "Avanzado",
      addZone: "Agregar zona",
      editZone: "Editar zona",
      noZonesConfigured: "No hay zonas configuradas",
      loadingZones: "Cargando zonas...",
      maxZonesReached: "Se alcanzó el límite de zonas (999)",

      // Standard tab
      zoneNumber: "Número de zona",
      zoneName: "Nombre de la zona",
      zoneType: "Tipo",
      zoneTypeOptions: {
        none: "Ninguno",
        night: "Noche",
        day: "Día",
        exit: "Salida",
        fire: "Incendio",
        supervisory: "Supervisión",
        fireVerify: "Verificación de incendio",
        panic: "Pánico",
        arming: "Armado",
        auxiliary1: "Auxiliar 1",
        auxiliary2: "Auxiliar 2",
        emergency: "Emergencia",
      },
      area: "Área",
      unassigned: "*SIN USO*",
      followArea: "Seguir área",
      armedAreas: "Áreas armadas",
      armedAreasHint: "Números de área separados por comas",
      expanderSerialNumber: "Número de serie del expansor",
      zoneLocation: "Ubicación de la zona",

      // Action tab
      doMessage: "Mensaje DO",
      doOutputFireBell: "Salida DO de campana de incendio",
      doOutputAction: "Acción de salida DO",
      dsMessage: "Mensaje DS",
      dsOutput: "Salida DS",
      dsOutputAction: "Acción de salida DS",
      aoMessage: "Mensaje AO",
      aoOutput: "Salida AO",
      aoOutputAction: "Acción de salida AO",
      asMessage: "Mensaje AS",
      asOutput: "Salida AS",
      asOutputAction: "Acción de salida AS",

      // Message options
      messageOptions: {
        trouble: "Falla",
        alarm: "Alarma",
        supervisory: "Supervisión",
        none: "Ninguno"
      },

      // Output action options
      outputActionOptions: {
        steady: "Fija",
        pulse: "Pulsada",
        latch: "Enclavada"
      },

      // Wireless tab
      wireless: "Inalámbrico",
      serialNumber: "Número de serie",
      contact: "Contacto",
      normallyOpen: "Normalmente abierto",
      supervisionTime: "Tiempo de supervisión",
      ledOperation: "Operación del LED",
      disarmDisable: "Deshabilitar al desarmar",
      wirelessPirPulseCount: "Conteo de pulsos del PIR inalámbrico",
      wirelessPirPulseSensitivity: "Sensibilidad de pulsos del PIR inalámbrico",
      wirelessPirPetImmunity: "Inmunidad a mascotas del PIR inalámbrico",

      // Sensitivity options
      sensitivityOptions: {
        low: "Baja",
        medium: "Media",
        high: "Alta"
      },

      // Pet immunity options
      petImmunityOptions: {
        full: "Completa",
        partial: "Parcial",
        none: "Ninguna"
      },

      // Wireless device types
      deviceTypes: {
        unknown: "Desconocido",
        universal: "Transmisor universal (1000000-1999999)",
        pir: "Detector de movimiento PIR (2000000-2999999)",
        glassbreak: "Detector de rotura de cristal (3000000-3999999)",
        holdup: "Botón de atraco (4000000-4999999)",
        keyfob: "Llavero (5000000-5999999)",
        smoke_co: "Detector de humo/CO (6000000-7999999)",
        four_zone_expander: "Expansor de 4 zonas (8000000-8999999)",
        wireless_pir: "PIR inalámbrico (9000000-9999999)",
        repeater_1100r: "Repetidor 1100R (13000000-13999999)"
      },

      // Advanced tab
      swingerBypass: "Swinger bypass",
      zoneRetard: "Retardo de zona",
      fastResponse: "Respuesta rápida",
      crossZone: "Zona cruzada",
      priority: "Prioridad",
      firePanelSlaveInput: "Entrada esclava del panel de incendio",
      zoneRealTimeStatus: "Estado de la zona en tiempo real",
      trafficCount: "Conteo de tránsito",
      lockdown: "Bloqueo",
      zoneAuditDays: "Días de auditoría de la zona",
      reportWithAccountNumber: "Reportar con número de cuenta",
      chimeSong: "Melodía de aviso",
      prewarPresignal: "Preaviso",
      entryDelayNumber: "Número de retardo de entrada",
      number: "Número",
      loadingZones: "Cargando zonas...",
      name: "Nombre",
      type: "Tipo",
      messages: {
        deleteConfirm: "¿Seguro que deseas eliminar esta zona?",
        deleteConfirmMessage: "Esta acción no se puede deshacer",
        deleteConfirmText: "Esta acción no se puede deshacer",
        limitReached: "Límite alcanzado",
        maxZonesAllowed: "Máximo 999 zonas permitidas",
        validationError: "Error de validación",
        validationErrorText: "Corrige los errores del formulario",
        warning: "Advertencia",
        serialNumberIsKeyFob: "El número de serie corresponde a un llavero",
        keyFobsCannotBeProgrammed: "Los llaveros no se pueden programar desde esta pantalla",
        zoneNumberExists: "El número de zona ya existe",
        zoneSavedSuccess: "Zona guardada correctamente",
        zoneCreatedSuccess: "Zona creada correctamente",
        zoneCreateSuccess: "Zona creada correctamente",
        zoneUpdatedSuccess: "Zona actualizada correctamente",
        zoneUpdateSuccess: "Zona actualizada correctamente",
        zoneDeleteSuccess: "Zona eliminada correctamente",
        zonesLoadError: "No se pudieron cargar las zonas",
        zoneSaveError: "No se pudo guardar la zona",
        zoneDeleteError: "No se pudo eliminar la zona",
        syncSuccess: "Zonas sincronizadas correctamente",
        syncError: "No se pudieron sincronizar las zonas",
        warning: "Advertencia"
      }
    },

    deviceSetup: {
      title: "Configuración de dispositivos",
      addDevice: "Agregar dispositivo",
      number: "Número",
      name: "Nombre",
      type: "Tipo",
      deviceDetails: "Detalles del dispositivo",
      general: "General",
      options734: "Opciones 734",
      loadingDevices: "Cargando dispositivos...",
      noDevicesConfigured: "No hay dispositivos configurados",
      maxDevicesReached: "Se alcanzó el número máximo de dispositivos",
      deviceNumber: "Número de dispositivo",
      deviceType: "Tipo de dispositivo",
      deviceCommunicationType: "Tipo de comunicación del dispositivo",
      serialNumber: "Número de serie",
      supervisionTime: "Tiempo de supervisión",
      accessAreas: "Áreas de acceso",
      egressAreas: "Áreas de egreso",
      displayAreas: "Áreas a mostrar",
      strikeTime: "Tiempo de cerradura",
      strikeDelay: "Retardo de cerradura",
      fireExit: "Salida de incendio",
      autoForceArm: "Armado forzado automático",
      publicDoor: "Puerta pública",
      privateDoor: "Puerta privada",
      outputGroup: "Grupo de salida",
      doorRealTimeStatus: "Estado de la puerta en tiempo real",
      override: "Anulación",
      sendDoorForcedMessage: "Enviar mensaje de puerta forzada",
      program734Options: "Programar opciones 734",
      activateZone2Bypass: "Activar bypass de la zona 2",
      relockOnZone2Change: "Rebloquear al cambiar la zona 2",
      zone2BypassTime: "Tiempo de bypass de la zona 2",
      activateZone3ReqToExit: "Activar zona 3 de solicitud de salida",
      zone3ReqToExitStrikeTime: "Tiempo de cerradura de la zona 3 de solicitud de salida",
      activateOnboardSpeaker: "Activar altavoz integrado",
      noCommunicationWithPanel: "Sin comunicación con el panel",
      cardFormat: "Opciones de tarjeta",
      wiegandCodeLength: "Longitud del código Wiegand",
      siteCodeLength: "Longitud del código de sitio",
      userCodePosition: "Posición del código de usuario",
      siteCodePosition: "Posición del código de sitio",
      userCodeLength: "Longitud del código de usuario",
      requireSiteCode: "Requerir código de sitio",
      numberOfUserCodeDigits: "Cantidad de dígitos del código de usuario",
      siteCode: "Código de sitio",
      enable734ToConfigureOptions: "Habilita las opciones 734 para configurar ajustes adicionales",
      confirmDeleteDevice: "¿Seguro que deseas eliminar el dispositivo '{name}'?",
      deviceCreated: "Dispositivo creado correctamente",
      deviceUpdated: "Dispositivo actualizado correctamente",
      deviceDeleted: "Dispositivo eliminado correctamente",
      errorSavingDevice: "Error al guardar el dispositivo",
      errorDeletingDevice: "Error al eliminar el dispositivo",
      cardOptions: "Opciones de tarjeta",
      siteCodes: "Códigos de sitio",
      addCardFormat: "Agregar formato de tarjeta",
      cardFormats: "Formatos de tarjeta",
      selectOrAddCardFormat: "Selecciona o agrega formatos de tarjeta",
      noCardFormats: "Sin formatos de tarjeta",
      newCardFormat: "Nuevo formato de tarjeta",
      editCardFormat: "Editar formato de tarjeta"
    },
    areaSchedules: {
      title: "Horarios de áreas",
      addNew: "Agregar nuevo",
      loading: "Cargando horarios de áreas",
      noSchedulesConfigured: "No hay horarios de áreas configurados",
      details: "Detalles del horario del área",
      areaNumber: "Número de área",
      areaNumberRange: "Rango válido: 01-32",
      schedules: "Horarios",
      schedulesHint: "Asigna hasta 8 horarios a esta área. Déjalo en blanco si no es necesario.",
      schedule: "Horario",
      number: "Número",
      selectArea: "Selecciona un área para ver sus detalles",
      selectSchedule: "Selecciona un horario",
      confirmDelete: "¿Eliminar el horario del área?",
      confirmDeleteMessage: "Esta acción no se puede deshacer",
      messages: {
        scheduleSaveSuccess: "Horario del área guardado correctamente",
        scheduleSaveError: "Error al guardar el horario del área",
        scheduleDeleteSuccess: "Horario del área eliminado correctamente",
        scheduleDeleteError: "Error al eliminar el horario del área",
      },
      notAssigned: "Sin asignar"
    },
    timeSchedules: {
      title: "Horarios",
      addNew: "Agregar nuevo",
      loading: "Cargando horarios",
      noSchedulesConfigured: "No hay horarios configurados",
      details: "Detalles del horario",
      scheduleNumber: "Número de horario",
      scheduleNumberRange: "Rango válido: 01-99",
      scheduleName: "Nombre del horario",
      temporarySchedule: "Horario temporal",
      beginDate: "Fecha de inicio",
      endDate: "Fecha de fin",
      openBeginActivate: "Abrir / Iniciar / Activar",
      closeEnd: "Cerrar / Finalizar",
      sunriseSunset: "Amanecer / Atardecer",
      beforeAfter: "Antes / Después",
      select: "Seleccionar",
      sunrise: "Amanecer",
      sunset: "Atardecer",
      number: "Número",
      name: "Nombre",
      selectSchedule: "Selecciona un horario para ver sus detalles",
      confirmDelete: "¿Eliminar el horario?",
      confirmDeleteMessage: "Esta acción no se puede deshacer",
      days: {
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sun: "Dom",
        mon: "Lun",
        tue: "Mar",
        wed: "Mié",
        thu: "Jue",
        fri: "Vie",
        sat: "Sáb",
      },
      holidays: {
        holidayA: "Día festivo A",
        holidayB: "Día festivo B",
        holidayC: "Día festivo C",
      },
      messages: {
        scheduleSaveSuccess: "Horario guardado correctamente",
        scheduleSaveError: "Error al guardar el horario",
        scheduleDeleteSuccess: "Horario eliminado correctamente",
        scheduleDeleteError: "Error al eliminar el horario",
      },
      beforeAfterOptions: {
        "5minbefore": "5 min. antes",
        "10minbefore": "10 min. antes",
        "15minbefore": "15 min. antes",
        "30minbefore": "30 min. antes",
        "45minbefore": "45 min. antes",
        "60minbefore": "60 min. antes",
        "5minafter": "5 min. después",
        "10minafter": "10 min. después",
        "15minafter": "15 min. después",
        "30minafter": "30 min. después",
        "45minafter": "45 min. después",
        "60minafter": "60 min. después",
      },
      noTimeSelected: "Sin hora seleccionada",
      resetButton: "Restablecer",
      closeButton: "Cerrar",
      copyTime: "Copiar hora",
      pasteTime: "Pegar hora",
      applyToAll: "Aplicar a todos"
    },
    templateConfig: {
      visualize: "Visualizar",
      template: "Template",
      template_name: "Nombre del template",
      created_at: "Creado el",
      updated_at: "Actualizado el",
      available: "Disponible",
      busy: "Ocupado",
      generateTemplate: "Generar template",
      applyTemplate: "Aplicar template",
      generateTemplateWarning: "Generar el template desde el panel puede tardar algunos minutos",
      deleteTemplate: "Eliminar template",
      deleteTemplateWarning: "El template no podrá recuperarse",
      generatingTemplate: "Generando template",
      generatedCorrectly: "Template generado correctamente",
      applyExisting: "Aplicar desde templates existentes",
      selectTemplate: "Selecciona el template",
      edit: "Editar template",
      saveTemplate: "Guardar template",
      saveTemplateMock: "Template guardado (mock)",
      saveTemplateSuccess: "Template guardado correctamente",
      saveTemplateError: "Error al guardar el template",
      saveTemplateValidationError: "Corrige los errores del formulario antes de guardar",
      confirmExitTitle: "¿Salir sin guardar?",
      confirmExitText: "Se perderán los cambios no guardados del template.",
      createFromScratch: "Crear desde cero",
      createTemplate: "Crear template",
      creatingTemplate: "Creando template",
      createdCorrectly: "Template creado correctamente",
      createTemplateError: "Error al crear el template",
      templateNamePlaceholder: "Nombre del template",
      templateDescriptionPlaceholder: "Descripción (opcional)",
      nameRequired: "El nombre es obligatorio",
      applying: "Aplicando template",
      appliedSuccess: "Template aplicado correctamente",
      errorApplying: "Error al aplicar el template",
      tryAgain: "Verifica el contenido del template e inténtalo de nuevo",
      step: "Paso",
      errorStep: "Este paso no se completó"
    },
    systemReport: {
      title: "Reporte del sistema",
      loading: "Cargando",
      zoneRestorals: "Restauraciones de zona",
      accessKeypadEnable: "Habilitar teclado de acceso",
      optionsSection: "Opciones",
      abortReports: "Reportes de cancelación",
      bypassReports: "Reportes de bypass",
      scheduleChangeReports: "Reportes de cambio de horario",
      codeChangeReports: "Reportes de cambio de código",
      ambushReports: "Reportes de coacción",
      videoSystemReports: "Reportes del sistema de video",
      lateToOpen: "Retraso en apertura",
      earlyToClose: "Cierre anticipado",
      savedSuccessfully: "Reporte del sistema guardado",
      errorSaving: "Error al guardar el reporte del sistema"
    },
    menuDisplay: {
      title: "Visualización del menú",
      loading: "Cargando",
      optionsSection: "Opciones",
      armedAreaStatusDisplay: "Mostrar estado de área armada",
      timeDisplay: "Mostrar hora",
      armDisarmDisplay: "Mostrar armado/desarmado",
      savedSuccessfully: "Visualización del menú guardada",
      errorSaving: "Error al guardar la visualización del menú"
    },
    statusList: {
      title: "Lista de estado",
      loading: "Cargando",
      optionsSection: "Opciones",
      systemTroubleStatusMonitors: "Monitores de estado de falla del sistema",
      fireZoneKeypads: "Teclados de zona de incendio",
      carbonMonoxideZoneKeypads: "Teclados de zona de monóxido de carbono",
      burglaryZoneKeypads: "Teclados de zona de robo",
      supervisoryZoneKeypads: "Teclados de zona de supervisión",
      panicZoneKeypads: "Teclados de zona de pánico",
      emergencyZoneKeypads: "Teclados de zona de emergencia",
      auxiliary1ZoneKeypads: "Teclados de zona auxiliar 1",
      auxiliary2ZoneKeypads: "Teclados de zona auxiliar 2",
      commPathTrouble: "Falla en la ruta de comunicación",
      yes: "Sí",
      no: "No",
      all: "Todos",
      savedSuccessfully: "Lista de estado guardada",
      errorSaving: "Error al guardar la lista de estado"
    },
    pcLogReport: {
      title: "Reportes de registro de PC",
      loading: "Cargando",
      optionsSection: "Opciones",
      netOptionsSection: "Opciones de red",
      armDisarmReports: "Reportes de armado/desarmado",
      zoneReports: "Reportes de zona",
      useCommandReports: "Reportes de uso de comandos",
      doorAccessReports: "Reportes de acceso a puertas",
      supervisoryReports: "Reportes de supervisión",
      realTimeStatus: "Estado en tiempo real",
      netIpAddress: "Dirección IP de red",
      netPort: "Puerto de red",
      savedSuccessfully: "Reporte de registro de PC guardado",
      errorSaving: "Error al guardar el reporte de registro de PC"
    },
    templates: "Templates",
    inProgress: "En progreso",
    virtual_bypass: "Bypass virtual",
    virtual_bypass_on: "Habilitado",
    virtual_bypass_off: "Deshabilitado",
    compositeAlarms: "Alarmas compuestas"
  }
}
